module.exports = __webpack_public_path__ + "img/标杆客户.578b2a60.png";